import { LfuiElement } from '#utils/element'
import styles from './lfds-heading.css.ts'
import { state, property } from 'lit/decorators.js'
import { html, literal, StaticValue, unsafeStatic } from 'lit/static-html.js'

/**
 * @name LfdsHeading
 *
 * @deprecated Moved to `@lansforsakringar/core-recipes/heading` as `<lfds-r-heading>`.
 * @status deprecated
 * @tag lfds-heading
 * @slot default - Content to be displayed in the heading
 */
export default class LfdsHeading extends LfuiElement {
	static styles = styles

	@state() tag: StaticValue = literal`h2`

	@property() variant: 'primary' | 'secondary' = 'primary'
	@property() level: 'h1' | 'h2' | 'h3' | 'h4' = 'h2'

	willUpdate(changed) {
		super.willUpdate(changed)

		if (changed.has('level')) {
			if (!['h1', 'h2', 'h3', 'h4'].includes(this.level)) {
				this.tag = literal`h2`
				console.error(`Invalid heading level: ${this.level}. Defaulting to h2.`)
			} else {
				this.tag = unsafeStatic(this.level)
			}
		}
	}

	render() {
		return html`
      <${this.tag} class="heading ${this.variant}">
        <slot></slot>
      </${this.tag}>
    `
	}
}
